// Font Awesome Free class names, in one place so the same concept gets the same
// glyph wherever it appears — the sidebar, the global search results, and the
// per-service menus all name their icons from here.
//
// Values are class strings ('fa-solid fa-cloud') because that is what nav tables
// carry as their `icon` field and what <Icon /> renders. Only the Free solid set
// is used; nothing here needs a Pro-only or brand glyph.
export const ICONS = {
  // Console areas (see services.consoleFeatures on the backend)
  home: 'fa-solid fa-house',
  services: 'fa-solid fa-table-cells-large',
  billing: 'fa-solid fa-file-invoice-dollar',
  costs: 'fa-solid fa-chart-pie',
  providers: 'fa-solid fa-cloud',
  iam: 'fa-solid fa-user-shield',
  contracts: 'fa-solid fa-file-contract',
  prices: 'fa-solid fa-tags',
  regions: 'fa-solid fa-earth-americas',
  compartments: 'fa-solid fa-folder-tree',
  superadmin: 'fa-solid fa-shield-halved',
  servers: 'fa-solid fa-server',

  // Service menus
  dashboard: 'fa-solid fa-gauge-high',
  list: 'fa-solid fa-list',
  create: 'fa-solid fa-plus',
  monitoring: 'fa-solid fa-chart-line',
  settings: 'fa-solid fa-gear',
  key: 'fa-solid fa-key',

  // Shell chrome and controls
  search: 'fa-solid fa-magnifying-glass',
  cloudShell: 'fa-solid fa-terminal',
  notifications: 'fa-solid fa-bell',
  help: 'fa-solid fa-circle-question',
  info: 'fa-solid fa-circle-info',
  menu: 'fa-solid fa-bars',
  close: 'fa-solid fa-xmark',
  refresh: 'fa-solid fa-rotate-right',
  history: 'fa-solid fa-clock-rotate-left',
  copy: 'fa-solid fa-copy',
  edit: 'fa-solid fa-pen',
  delete: 'fa-solid fa-trash',
  plus: 'fa-solid fa-plus',
  caretDown: 'fa-solid fa-caret-down',
  chevronLeft: 'fa-solid fa-chevron-left',
  chevronRight: 'fa-solid fa-chevron-right',
  arrowRight: 'fa-solid fa-arrow-right',
};

export default ICONS;
